import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWindow"><Path d="M9 7.5C9 8.32843 8.32843 9 7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM19 10H5V5H19V10ZM10 6.5H18V8.5H10V6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWindow;
